<script>
import EventLog from './EventLog/EventLog.vue'
import EventChart from './EventChart/EventChart.vue'

export default {
  name: 'Trend',
  components: {
    EventLog,
    EventChart

  },
  data () {
    return {
      page: 1,
      interval: null,
      commandInterval: null,
      lastTs: 0,
      countSelectValue: 0,
      eventData: {},
      beginTs: 0,
      time: 0
    }
  },
  watch: {
    page () {
      this.setInterval()
    },
    '$store.state.highSpdMode' () {
      this.setInterval()
    }
  },
  async mounted () {
    await this.updateData()
    await this.pollCommand()
    await this.setInterval()
    await this.setCountSelectValue(0)
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()

    // 关闭快速模式
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }
    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
    setCountSelectValue (index) {
      this.countSelectValue = index
      this.sendCommand(index)

      this.beginTs = this.eventData[index].ts
      this.time = index
    },
    currentPage (page) {
      this.page = page
    },
    setInterval () {
      if (this.page === 1) {
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.$api.getTs({
              collection: 'meter_event_data',
              sn: this.$store.state.sn
            }).then((res) => {
              if (res.data.code !== 0) {
                this.$message.error(res.data.msg)
                return
              }
              if (this.lastTs !== res.data.data.ts) {
                this.lastTs = res.data.data.ts
                this.updateData()
              }
            })
          }, 1000)
        }
        this.pollCommand()
      } else if (this.page === 2) {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        this.pollStop()
      }
    },

    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand(0xff)
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand(this.countSelectValue)
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },

    sendCommand (index) {
      // const m = (index + 1) << 4 & 0xf0 | 0x02
      const params = {
        sn: this.$store.state.sn,
        lists: [[1, 8, index]]
      }
      this.$api.command(params).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      let params = {
        'collection': 'meter_event_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'num': 128,
        'fields': ['event_time', 'event_type', 'event_cont_time', 'ts'],
        'transpose': false
      }
      const {data: res} = await this.$api.queryLastDatas(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      const eventData = res.data.filter((item) => {
        if (item.sag_time !== 0) {
          return item
        }
      })
      this.eventData = eventData
      this.$store.commit('updateEventData', eventData)
    }
  }
}
</script>

<template>
  <div class="page">
    <div class="dataBorder">
        <EventLog :setCountSelectValue="setCountSelectValue" :countSelectValue='countSelectValue'></EventLog>
        <div style="height: 100%; width: 49%; margin-left: 1%">
          <EventChart :countSelectValue='countSelectValue' :beginTs='beginTs' :time="time"></EventChart>
        </div>
    </div>
  </div>
</template>

<style scoped>
.page {
  width: 100%;
  height: 100%;
}

.dataBorder {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(90vh - 70px);
//overflow: auto; display: flex; flex-wrap: wrap; justify-content: space-between; font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Event/Event.vue